import { isSalesIdentity } from '@/lib/profileIdentity';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { useMyDay, useMyOutstanding, rupees } from './myDayData';
import { CallQueue, Today, MyProposals, OutstandingList, QueryState } from './MyDaySections';

export function SalesExecDashboard() {
  const user = useAuthStore(s => s.user);
  const dayQuery = useMyDay();
  const outstanding = useMyOutstanding();
  const day = dayQuery.data?.day;
  const cards = day ? [
    { label: 'Calls today', value: day.callsToday, detail: 'Calls recorded today', to: '/telecaller' },
    { label: 'Follow-ups due', value: day.followupsDue, detail: `${day.overdue} overdue`, to: '/follow-ups' },
    // 2026-10-08 (audit R11): ₹ = proposals the customer has (drafts counted, not summed).
    { label: 'Open proposals', value: day.proposals.length, detail: (() => {
      const sent = day.proposals.filter(p => p.status !== 'draft'); const drafts = day.proposals.length - sent.length;
      const money = sent.some(p => p.amount === null) ? 'Some amounts need review' : rupees(sent.reduce((sum, p) => sum + p.amount!, 0));
      return drafts ? `${money} sent · ${drafts} draft${drafts === 1 ? '' : 's'}` : money;
    })(), to: '/proposals' },
    { label: 'Won this month', value: day.won.count, detail: `${day.won.amount === null ? 'Value needs review' : rupees(day.won.amount)} · paid sales · incl. dealer`, to: isSalesIdentity(user) ? '/scorecard' : '/leads' },
  ] : [];
  return <div className="space-y-5">
    <header className="flex flex-wrap justify-between items-center gap-3">
      <div>
        <h1 className="text-2xl font-semibold">My Day</h1>
        <p className="text-sm text-[var(--ink-3)]">{[user?.firstName, user?.lastName].filter(Boolean).join(' ')} · {new Date().toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata', weekday: 'long', day: 'numeric', month: 'short' })}</p>
      </div>
      <div className="flex gap-2">
        <Link className="btn" to="/leads">Add lead</Link>
        <Link className="btn btn-primary" to="/quick-quote">Quick Quote</Link>
      </div>
    </header>
    <div aria-label="My Day KPIs" className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
      {day ? cards.map(card => <Link key={card.label} to={card.to} className="card p-4">
        <span className="block text-sm">{card.label}</span>
        <strong className="block text-2xl my-2">{card.value}</strong>
        <span className="text-xs text-[var(--ink-3)]">{card.detail}</span>
      </Link>) : <div className="xl:col-span-4 card">
        <QueryState label="My Day" error={dayQuery.error} retry={dayQuery.retry} />
      </div>}
      {outstanding.data ? <Link to="/my-outstanding" className="card p-4">
        <span className="block text-sm">My outstanding</span>
        <strong className="block text-2xl my-2">{rupees(outstanding.data.total)}</strong>
        <span className="text-xs">{outstanding.data.rows.length} unpaid orders</span>
      </Link> : <div className="card">
        <QueryState label="My Outstanding" error={outstanding.error} retry={outstanding.retry} />
      </div>}
    </div>
    {dayQuery.data && <div className="grid gap-4 lg:grid-cols-3">
      <div className="lg:col-span-2">
        <CallQueue rows={dayQuery.data.queue} />
      </div>
      <Today rows={dayQuery.data.day.today} />
    </div>}
    <div className="grid gap-4 lg:grid-cols-3">{day && <div className="lg:col-span-2">
      <MyProposals rows={day.proposals} />
    </div>}{outstanding.data && <OutstandingList data={outstanding.data} />}</div>
  </div>;
}
